export const TOKEN_TYPE = 'Bearer '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'


// ------------------ URLS PRODUCCION ------------------

export const URL_APP_MOVIL = 'https://appmovil.cmsiglo21.app/api'
export const URL_EVENTOS_ADVERSOS = 'https://adversos-api.cmsiglo21.app/api'
export const URL = 'https://intranet-api.cmsiglo21.app/api'
export const URL_CHAT= 'https://socketchat-api.cmsiglo21.app'
export const URL_MSUSUARIOS = 'https://ms-usuarios.cmsiglo21.app/api'
export const URL_XUSER = 'https://xuser-api.cmsiglo21.app/api'
export const SAILS_URL = 'https://appmovil.cmsiglo21.app'
export const SAILS_URL_INTRANET = 'https://intranet-api.cmsiglo21.app'

// ------------------ URLS DESARROLLO ------------------


//export const URL_APP_MOVIL = 'http://172.20.12.160:1338/api'
// export const URL_EVENTOS_ADVERSOS = 'http://172.20.1.59:1343/api'
//export const URL = 'http://172.20.1.59:1340/api'
// export const URL_CHAT= 'http://172.20.12.160:3018'




//export const URL = 'https://intranet-api.cmsiglo21.app/api'
// export const URL_APP_MOVIL = 'http://172.20.12.84:1338/api'
// export const URL = 'http://172.20.12.84:1338/api'
//export const URL = 'http://172.20.12.97:1338/api'
//export const URL = 'http://172.20.1.59:1338/api'
// export const URL_MSUSUARIOS = 'http://172.20.12.84:1337/api'
//export const URL_MSUSUARIOS = 'http://172.20.6.46:1337/api
//export const URL_MSUSUARIOS = 'http://localhost:1337/api'
// export const URL_LOCAL = 'http://172.20.6.46:1338/api'
//export const SAILS_URL = 'https://intranet-api.cmsiglo21.app'
// export const SAILS_URL = 'http://localhost:1338'
//ms.usuarios.jeffrycoder.com/api
//appmovil.jeffrycoder.com/api
